import { Box, Paper, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ToolbarRoot = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  flexDirection: 'row',
  flexShrink: 0,
  gap: theme.spacing(1),
  justifyContent: 'space-between',
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(1),
}));

export const ToolbarContent = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const NavigationHint = styled(Paper)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  minHeight: theme.spacing(3),
  paddingInline: theme.spacing(1),
}));

export const NavigationHintText = styled(Typography)({
  whiteSpace: 'nowrap',
});
